import React from 'react';
import { Typography, List, ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';

const NumberedList = ({ title, items, borderColor = '#ff6a49' }) => (
  <Box>
    {title && (
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#0C3058', mb: 0 }}>
        {title}
      </Typography>
    )}
    <List sx={{ mb: 3 }}>
      {items.map((item, idx) => (
        <ListItem sx={{ px: 0, py: 0, alignItems: 'center', pb: 0 }} key={idx}>
          <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: '#fff',
                color: '#0C3058',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                border: `1px solid ${borderColor}`,
              }}
            >
              {idx + 1}
            </Box>
          </ListItemIcon>
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </List>
  </Box>
);

export default NumberedList; 